import poNeeded from './poNeeded.vue';

if (document.querySelector('#po-needed-table')) {
  const orders = document.querySelector('#po-needed-table').dataset.orders;

  var app = new Vue({
    el: '#po-needed-table',
    template: '<poNeeded :orders="this.orders"/>',
    components: {
      poNeeded
    },
    data(){
      return {
        orders: JSON.parse(orders)
      };
    },
    created() {
      window.vue = this;
    }
  });
}